import { useEffect, useMemo, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"

import { getTemplateLibrary, useCreateMessageTemplateOldMutation } from "store/api/contractorsApi"
import { useAppSelector } from "store/hooks"
import { ApiTypes, UITypes } from "types"

import getErrorMessage from "utils/getErrorMessage"
import { MessageForm } from "components/form/MessageFormOld"

export const MessageTemplateAdd = () => {
  const [triggerCreateMessageTemplate, { isLoading }] = useCreateMessageTemplateOldMutation()
  const [currentTemplateLibrary, setCurrentTemplateLibrary] = useState<ApiTypes.Model.TemplatesLibraryItem | null>(null)
  const [searchParams] = useSearchParams()
  const templateId = searchParams.get("id")
  const selecttTemplateLibrary = useMemo(() => getTemplateLibrary.select(), [])
  const templateLibrary = useAppSelector(selecttTemplateLibrary)

  const navigate = useNavigate()

  const trasformEditData = (): UITypes.MessageTemplate | undefined => {
    if (!currentTemplateLibrary) return undefined

    return {
      title: currentTemplateLibrary?.title,
      message: currentTemplateLibrary?.description,
      message_rich: currentTemplateLibrary?.description_rich,
    }
  }

  const onSetCurrentTemplate = () => {
    const templatesList = templateLibrary?.data?.data
    if (!templateId || !templatesList?.length) {
      setCurrentTemplateLibrary(null)
    } else {
      const currentTemplate = templatesList
        ?.flatMap(library => library?.items)
        ?.filter(item => item.id === Number(templateId))[0]
      setCurrentTemplateLibrary(currentTemplate)
    }
  }

  const onCreateTemplate = async (data: UITypes.MessageTemplate) => {
    try {
      const res = await triggerCreateMessageTemplate({
        title: data.title,
        body: data.message,
        body_rich: data.message_rich || "",
        repeat_every: "never",
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
        return false
      } else {
        toast.success("Message template has been successfully added!")
        navigate("/messages/add-template")
        setCurrentTemplateLibrary(null)
      }
    } catch (error) {
      console.error(error)
      return false
    }
  }

  useEffect(() => {
    onSetCurrentTemplate()
  }, [templateLibrary, templateId])

  return <MessageForm isLoading={isLoading} onSave={onCreateTemplate} editableTemplate={trasformEditData()} />
}
